import React from "react";
import Popup from "reactjs-popup";
import { Play, X, Image as ImageIcon, Plus } from "lucide-react";
import example from "./Pages/example.mp4";

function SliderShow() {
  const data = [
    {
      id: 1,
      attachment:
        "https://i.ibb.co/8KcrML6/465515713-18047723030506037-3586469520068209461-n.jpg",
      type: 2,
    },
    {
      id: 2,
      attachment:
        "https://i.ibb.co/7CKwStk/465750345-18047723057506037-1964922867198231648-n.jpg",
      type: 2,
    },
    {
      id: 3,
      attachment:
        "https://i.ibb.co/7JrT45M/465820547-18047722988506037-1525478395742935929-n.jpg",
      type: 2,
    },
    {
      id: 4,
      attachment:
        "https://i.ibb.co/4NB6r94/465852172-18047723009506037-3006684529859806868-n.jpg",
      type: 2,
    },
    {
      id: 5,
      attachment:
        "https://i.ibb.co/8KcrML6/465515713-18047723030506037-3586469520068209461-n.jpg",
      type: 2,
    },
    { id: 6, attachment: example, type: 1 },
    {
      id: 7,
      attachment:
        "https://i.ibb.co/7CKwStk/465750345-18047723057506037-1964922867198231648-n.jpg",
      type: 2,
    },
  ];

  const topItems = data.slice(0, 3);
  const bottomItems = data.slice(3, 7);

  return (
    <section className="bg-white py-12 md:py-16 lg:py-20 overflow-hidden">
      <div className="container max-w-7xl mx-auto px-4 sm:px-5 md:px-6 lg:px-8">
        {/* Header Section */}
        <div
          className="flex flex-col md:flex-row justify-between items-start md:items-end gap-3 md:gap-4 mb-8 md:mb-10 lg:mb-12"
          dir="rtl"
        >
          <div className="relative">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-2 leading-tight">
              البومات الصور والفيديو
            </h2>
            <div className="h-1 w-16 sm:w-20 md:w-24 bg-amber-400 rounded-full"></div>
          </div>
          <p className="text-gray-500 max-w-sm text-right text-xs sm:text-sm leading-relaxed">
            توثيق ميداني شامل لأبرز الأنشطة والمشاريع الخيرية التي تم تنفيذها
            مؤخراً.
          </p>
        </div>

        {/* Top Row: 3 Items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-5 mb-4 sm:mb-5">
          {topItems.map((item) => (
            <GalleryItem
              key={item.id}
              item={item}
              height="h-[250px] xs:h-[280px] sm:h-[320px] md:h-[350px] lg:h-[380px]"
            />
          ))}
        </div>

        {/* Bottom Row: 4 Items (Last one is "Watch More") */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
          {bottomItems.map((item, index) => {
            const isLastInRow = index === bottomItems.length - 1;

            if (isLastInRow) {
              return <WatchMoreButton key={item.id} item={item} />;
            }

            return (
              <GalleryItem
                key={item.id}
                item={item}
                height="h-[180px] xs:h-[200px] sm:h-[220px] md:h-[250px] lg:h-[280px]"
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

// Sub-component for individual Gallery items
function GalleryItem({ item, height }) {
  return (
    <Popup
      trigger={
        <div
          className={`relative ${height} w-full overflow-hidden rounded-xl sm:rounded-2xl shadow-sm hover:shadow-xl cursor-pointer group transition-all duration-300`}
        >
          <div className="absolute inset-0 bg-black/10 group-hover:bg-black/40 z-10 transition-all duration-300" />

          <div className="absolute inset-0 flex items-center justify-center z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="bg-white/95 p-2.5 sm:p-3 md:p-4 rounded-full text-[#163A8F] shadow-xl transform scale-75 group-hover:scale-100 transition-transform">
              {item.type === 1 ? (
                <Play
                  fill="currentColor"
                  size={18}
                  className="sm:w-5 sm:h-5 md:w-6 md:h-6"
                />
              ) : (
                <ImageIcon size={18} className="sm:w-5 sm:h-5 md:w-6 md:h-6" />
              )}
            </div>
          </div>

          {item.type === 1 ? (
            <video
              src={item.attachment}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              muted
              playsInline
            />
          ) : (
            <img
              src={item.attachment}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              alt=""
            />
          )}
        </div>
      }
      modal
      overlayStyle={{
        background: "rgba(0,0,0,0.92)",
        backdropFilter: "blur(8px)",
        zIndex: 1000,
      }}
      contentStyle={{
        width: "95%",
        maxWidth: "1100px",
        background: "transparent",
        border: "none",
        padding: 0,
      }}
    >
      {(close) => (
        <div className="relative w-full h-[70vh] sm:h-[80vh] md:h-[85vh] flex items-center justify-center bg-black rounded-xl sm:rounded-2xl md:rounded-3xl overflow-hidden group/modal">
          {/* CLEAN CLOSE BUTTON */}
          <button
            onClick={close}
            className="absolute top-3 sm:top-4 md:top-6 left-3 sm:left-4 md:left-6 z-[110] bg-white/20 hover:bg-white/40 p-2 sm:p-2.5 md:p-3 rounded-full text-white transition-all hover:rotate-90"
          >
            <X
              size={20}
              className="sm:w-6 sm:h-6 md:w-7 md:h-7"
              strokeWidth={2.5}
            />
          </button>

          {item.type === 1 ? (
            <video
              src={item.attachment}
              controls
              autoPlay
              className="w-full h-full object-contain px-2 sm:px-4"
            />
          ) : (
            <img
              src={item.attachment}
              className="w-full h-full object-contain px-2 sm:px-4"
              alt=""
            />
          )}
        </div>
      )}
    </Popup>
  );
}

// Watch More Integrated Button
function WatchMoreButton({ item }) {
  return (
    <button className="group relative flex items-center justify-center h-[180px] xs:h-[200px] sm:h-[220px] md:h-[250px] lg:h-[280px] w-full overflow-hidden rounded-xl sm:rounded-2xl shadow-md hover:shadow-xl transition-all duration-300">
      {item.type === 1 ? (
        <video
          src={item.attachment}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          muted
          playsInline
        />
      ) : (
        <img
          src={item.attachment}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          alt=""
        />
      )}

      <div className="absolute inset-0 bg-[#163A8F]/85 group-hover:bg-[#163A8F]/95 transition-colors z-10" />

      <div className="relative z-20 flex flex-col items-center gap-1 sm:gap-1.5 md:gap-2 px-2">
        <span className="text-white text-sm sm:text-base md:text-lg font-bold">
          مشاهدة المزيد
        </span>
        <div className="p-1 sm:p-1.5 md:p-2 bg-amber-400 rounded-full text-neutral-900 transform group-hover:rotate-90 transition-transform">
          <Plus
            size={14}
            className="sm:w-4 sm:h-4 md:w-5 md:h-5"
            strokeWidth={3}
          />
        </div>
      </div>
    </button>
  );
}

export default SliderShow;
